export default "__VITE_ASSET__70a971cf__"